import styled from "styled-components";

export const Container = styled.div`
    
`;

export const Frame = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 2em;
    width: 100%;
    max-width: 850px;
`;